// Configuration des tours guidés par espace

export const TOUR_CONFIGS = {
  member: {
    title: 'Bienvenue dans votre Espace Membre',
    subtitle: 'Découvrez les fonctionnalités essentielles',
    icon: '👤',
    color: 'from-blue-500 to-indigo-600',
    steps: [
      {
        target: '[data-tour="sidebar"]',
        title: 'Navigation',
        content: 'Accédez rapidement à toutes vos fonctionnalités depuis ce menu latéral.',
        position: 'right',
        icon: '📌'
      },
      {
        target: '[data-tour="wallet"]',
        title: 'Vos Crédits ESS',
        content: 'Suivez votre solde de crédits et effectuez vos achats en un clic.',
        position: 'bottom',
        icon: '💳'
      },
      {
        target: '[data-tour="souscriptions"]',
        title: 'Mes Souscriptions',
        content: 'Consultez et gérez toutes vos souscriptions actives et historiques.',
        position: 'bottom',
        icon: '📋'
      },
      {
        target: '[data-tour="documents"]',
        title: 'Documents',
        content: 'Retrouvez tous vos documents, attestations et certificats.',
        position: 'left',
        icon: '📁'
      },
      {
        target: '[data-tour="help"]',
        title: 'Centre d\'Aide',
        content: 'Besoin d\'aide ? Notre centre d\'assistance est toujours disponible.',
        position: 'top',
        icon: '❓'
      }
    ]
  },
  cooper: {
    title: 'Bienvenue dans l\'Espace COOPER\'S',
    subtitle: 'Gérez efficacement vos membres et souscriptions',
    icon: '🏢',
    color: 'from-amber-500 to-orange-600',
    steps: [
      {
        target: '[data-tour="wallet-credits"]',
        title: 'Crédits ESS',
        content: 'Gérez votre portefeuille de crédits pour vos opérations quotidiennes.',
        position: 'right',
        icon: '💰'
      },
      {
        target: '[data-tour="ftpe-membres"]',
        title: 'FTPE Membres',
        content: 'Inscrivez vos membres à la FTPE Outremer en quelques clics.',
        position: 'right',
        icon: '🏛️'
      },
      {
        target: '[data-tour="simulateur"]',
        title: 'Simulateur BATICO',
        content: 'Calculez les garanties RCDS pour vos clients professionnels.',
        position: 'right',
        icon: '🧮'
      },
      {
        target: '[data-tour="membres"]',
        title: 'Gestion Membres',
        content: 'Suivez et administrez tous vos membres adhérents.',
        position: 'right',
        icon: '👥'
      },
      {
        target: '[data-tour="statistiques"]',
        title: 'Statistiques',
        content: 'Analysez vos performances avec des tableaux de bord détaillés.',
        position: 'right',
        icon: '📊'
      }
    ]
  },
  expert: {
    title: 'Bienvenue dans l\'Espace Expert',
    subtitle: 'Outils professionnels pour experts et courtiers',
    icon: '🎯',
    color: 'from-violet-500 to-purple-600',
    steps: [
      {
        target: '[data-tour="wallet-credits"]',
        title: 'Wallet & Crédits',
        content: 'Votre portefeuille pour les opérations d\'expertise.',
        position: 'right',
        icon: '💎'
      },
      {
        target: '[data-tour="simulateur"]',
        title: 'Simulateurs',
        content: 'Accédez aux calculateurs professionnels BATICO, DOS et CCMI.',
        position: 'right',
        icon: '📐'
      },
      {
        target: '[data-tour="dommages"]',
        title: 'Gestion Dommages',
        content: 'Déclarez et suivez les dommages de vos clients.',
        position: 'right',
        icon: '⚠️'
      },
      {
        target: '[data-tour="conventions"]',
        title: 'Conventions',
        content: 'Gérez vos conventions de partenariat.',
        position: 'right',
        icon: '📝'
      },
      {
        target: '[data-tour="signature"]',
        title: 'Signature',
        content: 'Personnalisez votre signature et tampon professionnel.',
        position: 'right',
        icon: '✍️'
      }
    ]
  },
  super_admin: {
    title: 'Console Super Administrateur',
    subtitle: 'Contrôle total de la plateforme',
    icon: '👑',
    color: 'from-rose-500 to-pink-600',
    steps: [
      {
        target: '[data-tour="overview"]',
        title: 'Vue d\'ensemble',
        content: 'Statistiques globales et indicateurs clés de la plateforme.',
        position: 'bottom',
        icon: '📈'
      },
      {
        target: '[data-tour="users"]',
        title: 'Gestion Utilisateurs',
        content: 'Administrez tous les utilisateurs et leurs permissions.',
        position: 'right',
        icon: '👥'
      },
      {
        target: '[data-tour="ftpe-adhesions"]',
        title: 'Adhésions FTPE',
        content: 'Gérez et validez les adhésions à la fédération.',
        position: 'right',
        icon: '🏛️'
      },
      {
        target: '[data-tour="analytics"]',
        title: 'Analytics',
        content: 'Analysez le trafic et l\'utilisation de la plateforme.',
        position: 'right',
        icon: '📊'
      },
      {
        target: '[data-tour="annonces"]',
        title: 'Annonces',
        content: 'Diffusez des messages à tous les utilisateurs.',
        position: 'right',
        icon: '📢'
      }
    ]
  }
};

// Spotlight Overlay Component
